import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
export const useAuthStore = create()(persist((set) => ({
    accessToken: null,
    user: null,
    lastAuthAt: null,
    mfaVerified: false,
    setAuth: ({ accessToken, user }) => set({ accessToken, user, lastAuthAt: Date.now(), mfaVerified: false }),
    setMfaVerified: (verified) => set({ mfaVerified: verified }),
    clearAuth: () => set({ accessToken: null, user: null, lastAuthAt: null, mfaVerified: false }),
}), {
    name: 'ww-arthur-auth',
    storage: createJSONStorage(() => localStorage),
    partialize: (state) => ({
        accessToken: state.accessToken,
        user: state.user,
        lastAuthAt: state.lastAuthAt,
        mfaVerified: state.mfaVerified,
    }),
}));
/** True if the user holds ANY of the requested roles. */
export function hasAnyRole(user, ...roles) {
    if (!user?.roles?.length)
        return false;
    return roles.some((r) => user.roles.includes(r));
}
export function isOwner(user) {
    return hasAnyRole(user, 'owner');
}
/** Who can see the billing surface (customer billing info, MRR, invoices). */
export function canSeeBilling(user) {
    return hasAnyRole(user, 'owner', 'billing_admin');
}
/** Who can see platform-level admin (metrics, feature flags, staff mgmt). */
export function canSeePlatform(user) {
    return hasAnyRole(user, 'owner');
}
/** Who can see customer-facing surfaces (orgs, users, impersonation). */
export function canSeeCustomers(user) {
    return hasAnyRole(user, 'owner', 'billing_admin', 'support');
}
